export const cyStyle = [
	{
		selector: 'core',
		style: {
			'selection-box-color': '#AAD8FF',
			'selection-box-border-color': '#8BB0D0',
			'selection-box-opacity': '0.5',
		},
	},
	{
		selector: 'node',
		style: {
			width: 'mapData(score, 0, 0.007, 10, 20)',
			height: 'mapData(score, 0, 0.007, 10, 20)',
			content: 'data(name)',
			'font-size': '10px',
			'text-valign': 'center',
			'text-halign': 'center',
			'text-outline-width': '2px',
			color: '#fff',
			'z-index': '10',
		},
	},
	{
		selector: "node[type='gene']",
		style: {
			'background-color': '#5e67b2',
			'background-color': '#5e67b2',
			'text-outline-color': '#5e67b2',
		},
	},
	{
		selector: "node[type='lncRNA']",
		style: {
			'background-color': '#72b05f',
			'background-color': '#72b05f',
			'text-outline-color': '#72b05f',
		},
	},
	{
		selector: "node[type='validate_lncRNA']",
		style: {
			'background-color': '#b3524a',
			'background-color': '#b3524a',
			'text-outline-color': '#b3524a',
		},
	},
	{
		selector: "node[type='miRNA']",
		style: {
			'background-color': '#b29e2d',
			'background-color': '#b29e2d',
			'text-outline-color': '#b29e2d',
		},
	},
	{
		selector: "node[type='isoform_id']",
		style: {
			'background-color': '#5e67b2',
			'background-color': '#5e67b2',
			'text-outline-color': '#5e67b2',
		},
	},
	{
		selector: "node[type='other']",
		style: {
			'background-color': '#5e67b2',
			'background-color': '#5e67b2',
			'text-outline-color': '#5e67b2',
		},
		// }, {
		//     "selector": "node:selected",
		//     "style": {
		//         "border-width": "6px",
		//         "border-color": "#AAD8FF",
		//         "border-opacity": "0.5",
		//         "background-color": "#77828C",
		//         "text-outline-color": "#77828C"
		//     }
	},
	{
		selector: 'edge',
		style: {
			'curve-style': 'haystack',
			'haystack-radius': '0.5',
			opacity: '0.5',
			'line-color': '#e8e8e8',
			// "width": "mapData(weight, 0, 1, 1, 1)",
			width: '1px',
			'overlay-padding': '3px',
		},
	},
	{
		selector: 'node.unhighlighted',
		style: {
			opacity: '0.2',
		},
	},
	// {
	// 	selector: 'edge.unhighlighted',
	// 	style: {
	// 		opacity: '0.05',
	// 	},
	// },
	{
		selector: '.highlighted',
		style: {
			'z-index': '999999',
		},
	},
	{
		selector: 'node.highlighted',
		style: {
			'border-width': '6px',
			'border-color': '#AAD8FF',
			'border-opacity': '0.5',
			'background-color': '#394855',
			'text-outline-color': '#394855',
		},
	},
	{
		selector: 'edge.filtered',
		style: {
			opacity: '0',
		},
	},
	{
		selector: 'edge[weight < 0]',
		style: {
			'line-color': '#50b4ce',
		},
	},
	{
		selector: 'edge[weight > 0]',
		style: {
			'line-color': '#50b4ce',
		},
	},
	{
		selector: 'edge[validate=1.0]',
		style: {
			'line-color': '#b3524a',
		},
	},
	// {
	// 	selector: 'edge[weight < -0.9]',
	// 	style: {
	// 		width: '3px',
	// 	},
	// },
	// {
	// 	selector: 'edge[weight < -0.6][weight >= -0.9]',
	// 	style: {
	// 		width: '2px',
	// 	},
	// },
	// {
	// 	selector: 'edge[weight < 0][weight >= -0.6]',
	// 	style: {
	// 		width: '1px',
	// 	},
	// },
	// {
	// 	selector: 'edge[weight < 0.6][weight >= 0]',
	// 	style: {
	// 		width: '1px',
	// 	},
	// },
	// {
	// 	selector: 'edge[weight < 0.9][weight >= 0.6]',
	// 	style: {
	// 		width: '2px',
	// 	},
	// },
	// {
	// 	selector: 'edge[weight >= 0.9]',
	// 	style: {
	// 		width: '3px',
	// 	},
	// }
]

export const layout = {
	name: 'random', //点的位置随机
	fit: false, // 是否适合视窗
	padding: 30, // fit 内边距
	boundingBox: undefined, // 约束布局范围 { x1, y1, x2, y2 } or { x1, y1, w, h }
	animate: true, // 是否启用动画
	animationDuration: 2000, // 在ms中激活动画的持续时间
	animationEasing: undefined, // easing of animation if enabled
	animateFilter: function (node, i) {
		return true
	}, // 决定节点是否应该动画。默认情况下激活动画的所有节点。非动画节点在布局开始时立即定位
	ready: undefined, // callback on layoutready
	stop: undefined, // callback on layoutstop
	transform: function (node, position) {
		return position
	},
}
